export enum BanksQueryKeys {
  Primary = '/banks/',
}
